module.exports = __webpack_public_path__ + "img/11.a112731b.jpg";